import { Box, UtilityText, Icon } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { MainPageContainer } from '@leagueplatform/web-common-components';
import { LinkComponent } from 'components/form-center/custom-link.component';
import pdfIcon from 'assets/pdf-icon.svg';
import { EXTERNAL_LINK } from 'common/constants';

export const FooterComponent = () => {
  const { formatMessage } = useIntl();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      as="footer"
      css={{
        background: '$decorativeBrandSecondaryDefault',
        paddingTop: '$three',
        paddingBottom: '$three',
      }}
    >
      <MainPageContainer
        width="100%"
        css={{
          paddingTop: '$oneAndHalf',
          paddingBottom: '$oneAndHalf',
          paddingLeft: '$two',
          paddingRight: '$two',
          '@md': {
            paddingLeft: '$oneAndHalf',
            paddingRight: '$oneAndHalf',
          },
        }}
      >
        {/* Footer Links */}
        <Box
          css={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '0 $oneAndHalf',
            marginBottom: '$oneAndHalf',
          }}
        >
          <LinkComponent
            text="STR_LEGAL_AND_PRIVACY"
            url={EXTERNAL_LINK.LEGAL_AND_PRIVACY}
            target="_blank"
            icon="interfaceExternalLink"
            linkProps={{
              color: '$onSurfaceTextReversed',
              fontSize: '12px',
              textDecoration: 'underline',
              display: 'inline-flex',
              alignItems: 'center',
              '&:hover': {
                color: '$onSurfaceTextReversed',
              },
            }}
          />
          <LinkComponent
            text="STR_GRIEVANCES_AND_APPEALS"
            url={EXTERNAL_LINK.GRIEVANCES_AND_APPEALS}
            target="_blank"
            icon="interfaceExternalLink"
            linkProps={{
              color: '$onSurfaceTextReversed',
              fontSize: '12px',
              textDecoration: 'underline',
              display: 'inline-flex',
              alignItems: 'center',
              '&:hover': {
                color: '$onSurfaceTextReversed',
              },
            }}
          />
          <LinkComponent
            text="STR_NONDISCRIMINATION_NOTICE"
            url={EXTERNAL_LINK.NONDISCRIMINATION_NOTICE}
            target="_blank"
            icon="interfaceExternalLink"
            linkProps={{
              color: '$onSurfaceTextReversed',
              fontSize: '12px',
              textDecoration: 'underline',
              display: 'inline-flex',
              alignItems: 'center',
              '&:hover': {
                color: '$onSurfaceTextReversed',
              },
            }}
          />
          <LinkComponent
            text="STR_LANGUAGE_ASSISTANCE"
            url={EXTERNAL_LINK.LANGUAGE_ASSISTANCE}
            target="_blank"
            icon="interfaceExternalLink"
            linkProps={{
              color: '$onSurfaceTextReversed',
              fontSize: '12px',
              textDecoration: 'underline',
              display: 'inline-flex',
              alignItems: 'center',
              '&:hover': {
                color: '$onSurfaceTextReversed',
              },
            }}
          />
        </Box>

        {/* HealthSpring Products Text */}
        <UtilityText
          size="xs"
          css={{
            color: '$onSurfaceTextReversed',
            fontSize: '12px',
            lineHeight: '18px',
            marginBottom: '$oneAndHalf',
          }}
        >
          {formatMessage({ id: 'STR_FOOTER_HEALTHSPRING_PRODUCTS' })}
        </UtilityText>

        {/* Copyright */}
        <UtilityText
          size="xs"
          css={{
            color: '$onSurfaceTextReversed',
            fontSize: '12px',
            marginBottom: '$oneAndHalf',
          }}
        >
          {formatMessage({ id: 'STR_COPYRIGHT_TEXT' }, { year: currentYear })}
        </UtilityText>

        {/* PDF Notice with Icon */}
        <Box
          css={{
            display: 'flex',
            alignItems: 'flex-start',
            marginBottom: '$oneAndHalf',
          }}
        >
          <img
            src={pdfIcon}
            alt="PDF"
            style={{
              marginRight: '8px',
              flexShrink: 0,
              width: '16px',
              height: '16px',
            }}
          />
          <UtilityText
            size="xs"
            css={{
              color: '$onSurfaceTextReversed',
              fontSize: '12px',
              lineHeight: '18px',
            }}
          >
            {formatMessage({ id: 'STR_FOOTER_PDF_NOTICE' })}
          </UtilityText>
        </Box>

        {/* External Site Notice with Icon */}
        <Box css={{ display: 'flex', alignItems: 'flex-start' }}>
          <Icon
            icon="interfaceExternalLink"
            size="$one"
            css={{
              color: '$onSurfaceTextReversed',
              marginRight: '$half',
              flexShrink: 0,
            }}
          />
          <UtilityText
            size="xs"
            css={{
              color: '$onSurfaceTextReversed',
              fontSize: '12px',
              lineHeight: '18px',
            }}
          >
            {formatMessage({ id: 'STR_FOOTER_EXTERNAL_SITE_NOTICE' })}
          </UtilityText>
        </Box>
      </MainPageContainer>
    </Box>
  );
};
